export const team:any[] = [
    {
        "fullname":"Commercial X",
        "visit_to":"Company A",
        "status":"visited"
    },{
        "fullname":"Commercial Y",
        "visit_to":"Company B",
        "status":"in progress"
    },{
        "fullname":"Commercial Z",
        "visit_to":"Company C",
        "status":"in progress"
    }
]
export const actions:any[] = [
    {
        "action":"Action 1 description",
        "id":1
    },{
        "action":"Action 2 description",
        "id":2
    },{
        "action":"Action 3 description",
        "id":3
    },{
        "action":"Action 4 description",
        "id":4
    },{
        "action":"Action 5 description",
        "id":5
    }
]
export const sectors:any[] = [
    {
        "sector":"Secteur d'activité 1",
        "uuid":1
    },{
        "sector":"Secteur d'activité 2",
        "uuid":2
    },{
        "sector":"Secteur d'activité 3",
        "uuid":3
    },{
        "sector":"Secteur d'activité 4",
        "uuid":4
    },{
        "sector":"Secteur d'activité 5",
        "uuid":5
    }
]
export const clients:any[] = [
    {
        "fullname":"client 1 RS",
        "uuid":1,
        "sector":1,
        "cities":[
            {
                "city":"Casablanca",
                "adresse":"adresse postale casablanca"
            },{
                "city":"eljadida",
                "adresse":"adresse postale eljadida"
            }
        ]
    },{
        "fullname":"client 2 RS",
        "uuid":2,
        "sector":1,
        "cities":[
            {
                "city":"rabat",
                "adresse":"adresse postale rabat"
            },{
                "city":"bouznika",
                "adresse":"adresse postale bouznika"
            }
        ]
    },{
        "fullname":"client 3 RS",
        "uuid":3,
        "sector":2,
        "cities":[
            {
                "city":"Mohammedia",
                "adresse":"adresse postale Mohammedia"
            },{
                "city":"kenitra",
                "adresse":"adresse postale kenitra"
            }
        ]
    },{
        "fullname":"client 4 RS",
        "uuid":4,
        "sector":2,
        "cities":[
            {
                "city":"Settat",
                "adresse":"adresse postale Settat"
            },{
                "city":"Berrchide",
                "adresse":"adresse postale Berrchide"
            }
        ]
    },{
        "fullname":"client 5 RS",
        "uuid":5,
        "sector":3,
        "cities":[
            {
                "city":"Agadir",
                "adresse":"adresse postale Agadir"
            },{
                "city":"Casablanca",
                "adresse":"adresse postale casablanca"
            }
        ]
    },{
        "fullname":"client 6 RS",
        "uuid":6,
        "sector":4,
        "cities":[
            {
                "city":"Marrakech",
                "adresse":"adresse postale Marrakech"
            },{
                "city":"Casablanca",
                "adresse":"adresse postale casablanca"
            }
        ]
    },{
        "fullname":"client 7 RS",
        "uuid":7,
        "sector":5,
        "cities":[
            {
                "city":"Safi",
                "adresse":"adresse postale safi"
            },{
                "city":"Casablanca",
                "adresse":"adresse postale casablanca"
            }
        ]
    },{
        "fullname":"client 8 RS",
        "uuid":8,
        "sector":5,
        "cities":[
            {
                "city":"Meknes",
                "adresse":"adresse postale Meknes"
            },{
                "city":"Fès",
                "adresse":"adresse postale Fès"
            }
        ]
    },{
        "fullname":"client 9 RS",
        "uuid":9,
        "sector":5,
        "cities":[
            {
                "city":"Tanger",
                "adresse":"adresse postale Tanger"
            },{
                "city":"Tetouane",
                "adresse":"adresse postale Tetouane"
            }
        ]
    },{
        "fullname":"client 10 RS",
        "uuid":10,
        "sector":3,
        "cities":[
            {
                "city":"Casablanca",
                "adresse":"adresse postale casablanca"
            }
        ]
    },
]